import React, { useContext, useEffect } from "react";

// reactstrap components
import { Spinner } from "reactstrap";

// core components
import { useQuery } from "react-query";
import ApiContext from "services/ApiContext";
import ShopContext from "services/ShopContext";
import "./packaging.css";
import DashBoardDisplay from "./PackReportDisplay";

const columnsForTable = [
  "Invoice",
  "OrderDate",
  "OrderSource",
  "Name",
  "QuantityInOrder",
  "TotalOrderCost",
  "GoldType",
  "FreeProduct",
  "CouponApplied",
  "Courier",
  "TrackingCode",
  "ShopOrderStatus",
];

function PackOrderDB() {
  const shopID = useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);

  const columns = [
    {
      name: "Invoice No",
      selector: (row) => row.Invoice,
      sortable: true,
      wrap: true,
    },
    {
      name: "Order Date",
      selector: (row) => new Date(row.OrderDate).toLocaleDateString("en-GB"),
      sortable: true,
      wrap: true,
    },
    {
      name: "Order Source",
      selector: (row) => row.OrderSource,
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
      wrap: true,
    },
    {
      name: "QTY",
      selector: (row) => row.QuantityInOrder,
      sortable: true,
      wrap: true,
    },
    {
      name: "Amount",
      selector: (row) => row.TotalOrderCost,
      sortable: true,
      wrap: true,
    },
    {
      name: "Gold Type",
      selector: (row) => row.GoldType,
    },
    {
      name: "Discount/ Gift",
      selector: (row) => row.FreeProduct.map((pic) => <div>{pic}</div>),
      sortable: true,
      wrap: true,
    },
    {
      name: "Promocode",
      selector: (row) => row.CouponApplied.map((pic) => <div>{pic}</div>),
      sortable: true,
      wrap: true,
    },
    {
      name: "Logistic",
      selector: (row) =>
        row.DeliveryType === "Courier" ? row.Courier : row.DeliveryType,
      sortable: true,
      wrap: true,
    },
    {
      name: "Tracking Number",
      selector: (row) => row.TrackingCode,
      sortable: true,
      wrap: true,
    },
  ];

  const { isLoading, data, isSuccess, isError, refetch } = useQuery(
    `/shop/${shopID}/Packaging/Order`,
    async () =>
      shopID !== "0" &&
      Axios.get(`/shop/${shopID}/Order/Packaging`, {
        params: {
          limitPerPage: 9999,
        },
      })
    // { refetchOnWindowFocus: false }
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  if (isLoading) {
    return (
      <div className="content d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="content d-flex align-items-center justify-content-center">
        <h3>Something goes wrong, try refresh the page</h3>
      </div>
    );
  }

  return (
    <DashBoardDisplay
      refetch={refetch}
      columns={columns}
      data={data.data.Result}
      isSuccess={isSuccess}
      isLoading={isLoading}
      columnsForTable={columnsForTable}
      filterList={[
        {
          field: "OrderSource",
          label: "Order Source",
        },
        {
          field: "Courier",
          label: "Logistic",
        },
        { field: "ShopOrderStatus", label: "Status" },
      ]}
      forCategory="order"
      trackingNo="TrackingNo"
      rowState="ShopOrderStatus"
      invoice="Invoice"
      dateShow="OrderDate"
      customerName="Name"
    />
  );
}

export default PackOrderDB;
